import { styled } from '@mui/material/styles';
import { Typography } from 'core/common/ui/ui-kit';
import { exitDurationMs } from 'core/common/ui/ui-kit/motion';

export const WrapperStyled = styled('div')``;

export const TextStyled = styled(Typography)<{ $isVisible: boolean }>`
  text-align: center;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transition: opacity ${exitDurationMs}ms ease-in-out;
`;
